export default __webpack_public_path__ + "static/intro-b8c868b54437f6c6c174592103ddf284.jpg";